import { ToastContainer } from 'react-toastify';

import { isWebView } from '@src/helpers';

import WebinarForm from '../WebinarForm';

import '../styles.scss';

const CreateWebinar = () => {
  return (
    <div className="webinar-container">
      {!isWebView() && <h4>Create a webinar meeting</h4>}
      <WebinarForm />
      <ToastContainer />
    </div>
  );
};

export default CreateWebinar;
